<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      :handle-delete="del"
      >
        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
            <h1><v-icon large>mdi-file-cog-outline</v-icon>{{ item['uuid'] }}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>
    <ProfileParameterSetForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <template>
      <div class="profileparametersetvalue-list">
        <Toolbar
          :handle-add="() => addHandlerSub('ProfileParameterSetValue',item)"
        />

        <v-container grid-list-xl fluid>
          <v-layout row wrap>
            <v-flex sm12>
              <h1>{{$t('profile.profileparameter.values')}}</h1>
            </v-flex>
            <v-flex lg12>
              <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
                <ProfileParameterSetValueFilterForm
                  ref="filterForm"
                  :values="filters"
                  slot="filter"
                />
              </DataFilter>

              <br />

              <v-data-table
                v-model="selected"
                :headers="headers"
                :items="itemsSub"
      :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
                :loading="isLoading"
                :loading-text="$t('global.loading')"
                :options.sync="options"
                :server-items-length="totalItems"
                class="elevation-1"
                item-key="@id"
                show-select
                @update:options="onUpdateOptions"
                @click:row="editHandlerSubEvent"
              >

                <ActionCell
                  slot="item.action"
                  slot-scope="props"
                  :handle-edit="() => editHandlerSub(item,'ProfileParameterSetValue',props.item)"
                ></ActionCell>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </template>
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ProfileParameterSetForm from '../../components/profileparameterset/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import ProfileParameterSetValueFilterForm from '../../components/profileparametersetvalue/Filter';
import DataFilter from '../../components/DataFilter';

const servicePrefix = 'ProfileParameterSet';

export default {
  name: 'ProfileParameterSetUpdate',
  servicePrefix,
  mixins: [ListMixin,UpdateMixin],
  components: {
    Loading,
    Toolbar,
    ProfileParameterSetForm,
    ActionCell,
    ProfileParameterSetValueFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('profile.profileparameter.profileparameter'), value: 'profileParameter.name' },
        { text: this.$t('profile.profileparameter.value'), value: 'value' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      filters: {
        'profileParameterSet' : this.$route.params.id,
      },
      selected: []
    };
  },
  computed: {
    ...mapFields('profileparameterset', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('profileparameterset', ['find']),
    ...mapGetters('profileparametersetvalue', {
      itemsSub: 'list'
    }),
    ...mapFields('profileparametersetvalue', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })

  },

  methods: {
    ...mapActions('profileparameterset', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    }),
    ...mapActions('profileparametersetvalue', {
        getPage: 'fetchAll',
    }),
    editHandlerSubEvent(value) {
      this.editHandlerSub(this.item,'ProfileParameterSetValue',value);
    }
  }
};
</script>
